import { TextInput } from "react-native";
import {
  tBrandCategory,
  tBrandEthosMap,
  tLongAddress,
  tOption,
  tPaymentMethod,
  tRepCategory,
  tRetailerCategory,
  tUserConnection,
} from "tmt_api/src/types/types";
import { tValidType } from "../components/FormInputs";

type tpFormatAddress = (myAddress: tLongAddress | undefined) => string;
export const formatAddress: tpFormatAddress = (myAddress) => {
  if (myAddress) {
    return `${myAddress.address2 ? myAddress.address2 + ", " : ""}${myAddress.address1}
${myAddress.city}, ${myAddress.state_or_province} ${myAddress.postal_code}
${myAddress.country_code}`;
  } else {
    return "No Address Given";
  }
};

export const optionToReadableText = (options: tOption[], selectedOption: string): string => {
  const foundOption = options.find((option) => option.myValue === selectedOption);
  return foundOption?.myLabel ?? foundOption?.myValue ?? "";
};

export const stringNotEmpty = (myString: string | undefined): boolean => {
  if (myString !== "" && myString !== undefined) {
    return true;
  }
  return false;
};

export const stringNumberNotEmpty = (myString: string | undefined): boolean => {
  return stringNotEmpty(myString) && myString !== "0";
};

export const isValidHttpUrl = (string: string): boolean => {
  let url;

  try {
    url = new URL(string);
  } catch (_) {
    return false;
  }

  return url.protocol === "http:" || url.protocol === "https:";
};

export const longAddressToString = (myAddress: tLongAddress): string => {
  return `${myAddress.address1}${myAddress.address2 ? ` ${myAddress.address2},` : ","} ${myAddress.city} ${
    myAddress.state_or_province
  } ${myAddress.postal_code}`;
};

export const formatLongAddress = (address?: tLongAddress): string => {
  if (!address) return "";
  const countryCode = address.country_code === "US" ? "" : address.country_code;
  return safeJoin([
    address.address1,
    address.address2,
    address.city,
    safeJoin([address.state_or_province, address.postal_code, countryCode], " "),
  ]);
};

export const formatShortAddress = (address?: tLongAddress): string => {
  if (!address) return "";
  const countryCode = address.country_code === "US" ? "" : address.country_code;
  return safeJoin([address.city, safeJoin([address.state_or_province, address.postal_code, countryCode], " ")]);
};

export const stringToInt = (myString: string): number => {
  return parseFloat(myString) / 100;
};

export const formatPhoneNumber = (value: string): string => {
  // if input value is falsy eg if the user deletes the input, then just return
  if (!value) return value;

  // clean the input for any non-digit values.
  const phoneNumber = value.replace(/[^\d]/g, "");

  // phoneNumberLength is used to know when to apply our formatting for the phone number
  const phoneNumberLength = phoneNumber.length;

  if (phoneNumberLength >= 11) {
    const newPhoneNumber = phoneNumber.substring(1);
    return `(${newPhoneNumber.slice(0, 3)}) ${newPhoneNumber.slice(3, 6)}-${newPhoneNumber.slice(6, 10)}`;
  }

  // we need to return the value with no formatting if its less then four digits
  // this is to avoid weird behavior that occurs if you  format the area code to early
  if (phoneNumberLength < 4) return phoneNumber;

  // if phoneNumberLength is greater than 4 and less the 7 we start to return
  // the formatted number
  if (phoneNumberLength < 7) {
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
  }

  // finally, if the phoneNumberLength is greater then seven, we add the last
  // bit of formatting and return it.
  return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
};

// TODO: Switch this to use libphonenumber-js  !!!  @Dayton-Lindsay
// export const formatPhoneNumber = (value: string): string => {
//   // if input value is falsy eg if the user deletes the input, then just return
//   if (!value) return value;

//   // clean the input for any non-digit values.
//   const phoneNumber = value.replace(/[^\d]/g, "");

//   // phoneNumberLength is used to know when to apply our formatting for the phone number
//   const phoneNumberLength = phoneNumber.length;

//   // if the phone number is less than 10 digits, then just return the input
//   // this is to prevent the user from entering a phone number that is less than 10 digits
//   // eg: if the user enters 123456789, then the phone number will be 123456789
//   if (phoneNumberLength < 10) return value;

//   // if the phone number is 10 digits, then format it as (123) 456-7890
//   if (phoneNumberLength === 10) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
//   }

//   // if the phone number is 11 digits, then format it as (123) 456-7890 x1234
//   if (phoneNumberLength === 11) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)} x${phoneNumber.slice(
//       11,
//       phoneNumberLength,
//     )}`;
//   }

//   // if the phone number is 12 digits, then format it as (123) 456-7890 x1234
//   if (phoneNumberLength === 12) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)} x${phoneNumber.slice(
//       11,
//       phoneNumberLength,
//     )}`;
//   }

//   // if the phone number is 13 digits, then format it as (123) 456-7890 x1234
//   if (phoneNumberLength === 13) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)} x${phoneNumber.slice(
//       11,
//       phoneNumberLength,
//     )}`;
//   }

//   // if the phone number is 14 digits, then format it as (123) 456-7890 x1234
//   if (phoneNumberLength === 14) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)} x${phoneNumber.slice(
//       11,
//       phoneNumberLength,
//     )}`;
//   }

//   // if the phone number is 15 digits, then format it as (123) 456-7890 x1234
//   if (phoneNumberLength === 15) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 7)}-${phoneNumber.slice(7, 11)} x${phoneNumber.slice(
//       11,
//       phoneNumberLength,
//     )}`;
//   }

//   // we need to return the value with no formatting if its less then four digits
//   // this is to avoid weird behavior that occurs if you  format the area code to early
//   if (phoneNumberLength < 4) return phoneNumber;

//   // if phoneNumberLength is greater than 4 and less the 7 we start to return
//   // the formatted number
//   if (phoneNumberLength < 7) {
//     return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
//   }

//   // finally, if the phoneNumberLength is greater then seven, we add the last
//   // bit of formatting and return it.
//   return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3, 6)}-${phoneNumber.slice(6, 10)}`;
// };

type tpCamelToTitle = (myCamelString: string) => string;
export const camelToTitle: tpCamelToTitle = (myCamelString) => {
  const result = myCamelString.replace(/([A-Z])/g, " $1");
  return result.charAt(0).toUpperCase() + result.slice(1);
};

type tpFormatMoney = (myMoney: string | number) => string;
export const formatMoney: tpFormatMoney = (myMoney) => {
  if (typeof myMoney === "number") {
    return myMoney.toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  } else {
    return Number.parseFloat(myMoney).toLocaleString("en-US", {
      style: "currency",
      currency: "USD",
    });
  }
};

export const formatMoneyShort = (value: string | number): string => formatMoney(value).split(".")[0];

export const formatMinMaxMoney = (min: number, max: number): string => {
  return min === max ? formatMoney(min) : `${formatMoney(min)}-${formatMoney(max)}`;
};

export const kBrandEthosConversion: Record<keyof tBrandEthosMap, string> = {
  awardWinning: "Award Winning",
  ecoFriendly: "Eco-Friendly",
  madeInAmerica: "Made In America",
  notOnAmazon: "Not On Amazon",
  organic: "Organic",
  smallBatch: "Small Batch",
  sustainable: "Sustainable",
  womanOwned: "Woman Owned",
  minorityOwned: "Minority Owned",
  exclusive: "UNUSED",
};

// export const _normalizeCompany = (myValue: string) => {
//   const _normalizeCompanyMatch = (myIndex: tCompanyElement) => myIndex.myValue === myValue;
//   const anIndex = aCompanyType.findIndex(_normalizeCompanyMatch);
//   return anIndex >= 0 ? aCompanyType[anIndex].myValue : aCompanyType[0].myValue;
// };
type tRefHandler = (ref: TextInput | null) => void;
export const errorFocus = (myValidList: tValidType, myUniqueName: string): tRefHandler => {
  return (ref: TextInput | null) => {
    if (ref && Object.prototype.hasOwnProperty.call(myValidList, myUniqueName) && !myValidList[myUniqueName]) {
      ref?.focus();
    }
  };
};

type tpNormalizeStateName = (myName: string) => string | undefined;
export const normalizeStateName: tpNormalizeStateName = (myName) => {
  const aName = myName?.toLowerCase();
  if (Object.prototype.hasOwnProperty.call(kStates, aName)) {
    return kStates[aName];
  } else {
    return undefined;
  }
};

type tConnectionSourceNames = "Direct" | "The Main Tab" | "TMT";
export const displayProperConnectionSource = (mySource: tConnectionSourceNames): tConnectionSourceNames => {
  if (mySource === "TMT") return "The Main Tab";
  return mySource;
};

export const formatPaymentMethod = (paymentMethod?: tPaymentMethod): string => {
  if (paymentMethod === "Net30") return "Net 30 Days";
  if (paymentMethod === "Net60") return "Net 60 Days";
  if (paymentMethod === "CreditCard") return "Credit Card";
  if (paymentMethod === "BankTransfer") return "Bank Transfer";
  return "Other";
};

export const formatFileSize = (size: number): string => {
  const i = Math.floor(Math.log(size) / Math.log(1024));
  const ble = size / Math.pow(1024, i);
  return `${ble.toFixed(2)} ${["B", "KB", "MB", "GB", "TB"][i]}`;
};

const kStates: { [key: string]: string } = {
  al: "Alabama",
  ak: "Alaska",
  as: "American Samoa",
  az: "Arizona",
  ar: "Arkansas",
  ca: "California",
  co: "Colorado",
  ct: "Connecticut",
  de: "Delaware",
  dc: "District of Columbia",
  fl: "Florida",
  ga: "Georgia",
  gu: "Guam",
  hi: "Hawaii",
  id: "Idaho",
  il: "Illinois",
  in: "Indiana",
  ia: "Iowa",
  ks: "Kansas",
  ky: "Kentucky",
  la: "Louisiana",
  me: "Maine",
  md: "Maryland",
  ma: "Massachusetts",
  mi: "Michigan",
  mn: "Minnesota",
  ms: "Mississippi",
  mo: "Missouri",
  mt: "Montana",
  ne: "Nebraska",
  nv: "Nevada",
  nh: "New Hampshire",
  nj: "New Jersey",
  nm: "New Mexico",
  ny: "New York",
  nc: "North Carolina",
  nd: "North Dakota",
  oh: "Ohio",
  ok: "Oklahoma",
  or: "Oregon",
  pa: "Pennsylvania",
  pr: "Puerto Rico",
  ri: "Rhode Island",
  sc: "South Carolina",
  sd: "South Dakota",
  tn: "Tennessee",
  tx: "Texas",
  ut: "Utah",
  vt: "Vermont",
  vi: "Virgin Islands",
  va: "Virginia",
  wa: "Washington",
  wv: "West Virginia",
  wi: "Wisconsin",
  wy: "Wyoming",
  alabama: "Alabama",
  alaska: "Alaska",
  "american samoa": "American Samoa",
  arizona: "Arizona",
  arkansas: "Arkansas",
  california: "California",
  colorado: "Colorado",
  connecticut: "Connecticut",
  delaware: "Delaware",
  "district of columbia": "District of Columbia",
  florida: "Florida",
  georgia: "Georgia",
  guam: "Guam",
  hawaii: "Hawaii",
  idaho: "Idaho",
  illinois: "Illinois",
  indiana: "Indiana",
  iowa: "Iowa",
  kansas: "Kansas",
  kentucky: "Kentucky",
  louisiana: "Louisiana",
  maine: "Maine",
  maryland: "Maryland",
  massachusetts: "Massachusetts",
  michigan: "Michigan",
  minnesota: "Minnesota",
  mississippi: "Mississippi",
  missouri: "Missouri",
  montana: "Montana",
  nebraska: "Nebraska",
  nevada: "Nevada",
  "new hampshire": "New Hampshire",
  "new jersey": "New Jersey",
  "new mexico": "New Mexico",
  "new york": "New York",
  "north carolina": "North Carolina",
  "north dakota": "North Dakota",
  ohio: "Ohio",
  oklahoma: "Oklahoma",
  oregon: "Oregon",
  pennsylvania: "Pennsylvania",
  "puerto rico": "Puerto Rico",
  "rhode island": "Rhode Island",
  "south carolina": "South Carolina",
  "south dakota": "South Dakota",
  tennessee: "Tennessee",
  texas: "Texas",
  utah: "Utah",
  vermont: "Vermont",
  "virgin islands": "Virgin Islands",
  virginia: "Virginia",
  washington: "Washington",
  "west virginia": "West Virginia",
  wisconsin: "Wisconsin",
  wyoming: "Wyoming",
};

export const capitalizeFirstLetter = (str: string): string => `${str.charAt(0).toUpperCase()}${str.slice(1)}`;

const kMap = {
  HomeDecor: "Home Decor",
  Lifestyle: "Lifestyle",
  Beauty: "Beauty",
  Gourmet: "Gourmet",
  Accessories: "Accessories",
  Wellness: "Wellness",
  Other: "Other",
  GiftShop: "Gift Shop",
  InteriorDesign: "Interior Design",
  Apothecary: "Apothecary",
  Fitness: "Fitness",
  Fashion: "Fashion",
  Spa: "Spa",
  Kids: "Kids",
  Bookstore: "Bookstore",
  General: "General",
  Stationary: "Stationary",
  Hospitality: "Hospitality",
  Botanical: "Botanical",
  SubscriptionBox: "Subscription Box",
  ECommerce: "ECommerce",
  Men: "Men",
  Pet: "Pet",
  International: "International",
  Publishing: "Publishing",
  Gift: "Gift",
} as const;

export const categoryToLabel = (
  key: tBrandCategory | tRetailerCategory | tRepCategory | Array<tRepCategory> | "",
): string => {
  if (key === "") return "";
  if (Array.isArray(key)) {
    return key.map((myValue) => (kMap[myValue] !== undefined ? kMap[myValue] : "")).join(", ");
  }
  if (kMap[key] !== undefined) {
    return kMap[key];
  }
  return key || "";
};

export const formatPercentNumber = (value?: number | null): number | null => {
  if (value === null || value === undefined) return null;
  return Number.parseFloat(formatInputPercent(value * 100));
};

export const formatInputPercent = (value: number): string =>
  new Intl.NumberFormat("en-US", { maximumFractionDigits: 2 }).format(value);

export const formatPercentage = (value: number): string =>
  new Intl.NumberFormat("en-US", { style: "percent", maximumFractionDigits: 2 }).format(value);

export const formatDate = (dateInMilliseconds: number): string =>
  new Date(dateInMilliseconds).toLocaleDateString("en-US");

export const formatShipping = (connection: tUserConnection): string =>
  `${connection.shipPercent ? formatPercentage(connection.shipPercent) : "-"}/${
    stringNotEmpty(connection.shipAccount) ? connection.shipAccount : "-"
  }`;

export const safeJoin = (terms: (string | undefined | null)[], separator = ", "): string =>
  terms.reduce((result, term) => {
    if (!term) return result;
    return (result?.length ?? 0) > 0 ? `${result}${separator}${term}` : `${term}`;
  }, "") ?? "";
